import declare from	"dojo/_base/declare";
import AggregateController from "csi/action/AggregateController";
import xml from	"csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import NewMixin from "csi/table/NewMixin";
import PostRequest from "csi/comm/PostRequest";

const AggregateBOMMaterialDataSheetsController = declare([AggregateController, NewMixin], {

	_preActionRequests(requests) {
		requests.push(new PostRequest("Specification", "UpdateMultiLevelOwnerSet").addParameter("URL", this.m_urlNode));
		this.inherited(arguments);
	},

	/**
     * @override
     * Add Parameter ParentURL with the value of Data Package 
     */
	toWriterRequest() {
		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("ParentURL", xml.ATTR_REF, this.getParent().__Parent__);
		return call;
	},

});

export = AggregateBOMMaterialDataSheetsController;